
// import React, { useState } from "react"
// import { emptyAllFields, getInputedValue } from "../../controllers/controller.utils";
// import { toast } from "react-toastify";
// import { SendMessage } from "../../services/service.api";

export default function ViewFooter(){

    // const [nom, setNom] = useState("");
    // const [email, setEmail] = useState("");
    // const [message, setMessage] = useState("");

    // function emptyAll(){
    //     emptyAllFields([setEmail, setNom, setMessage])
    // }

    // async function sendIt(e){
    //     e.preventDefault();
    //     if(nom && message){
    //         const mess = `CréaColors Afrique: Message de la part de ${nom} (${email}): ${message}`;
    //         const data = {
    //             "app_key": "647606299B1A3647606299B1A4",
    //             "sender": "CréaColors Afrique",
    //             "content": mess,
    //             "msisdn":["+33766422645"]
    //         }

    //         const result = await SendMessage(data);
            
            
    //         if(result?.error){
    //             toast.warning("Message non envoyé. Souci avec le serveur!")
    //         }else{
    //             toast.success("Message envoyé avec succès.");
    //         }
    //         emptyAll();
            
    //     }else{
    //         toast.warning("Veuillez saisir un nom et un message.");
    //     }
    // }

    return (
        <footer id="footer">
            {/* <section>
                <div>
                    <div className="fields">
                        <div className="field">
                            <label for="name">Nom*</label>
                            <input onChange={(e)=>getInputedValue(e, setNom)} value={nom} type="text" name="name" id="name" />
                        </div>
                        <div className="field">
                            <label for="email">Email / Téléphone</label>
                            <input onChange={(e)=>getInputedValue(e, setEmail)} value={email} type="text" name="email" id="email" />
                        </div>
                        <div className="field">
                            <label for="message">Message*</label>
                            <textarea onChange={(e)=>getInputedValue(e, setMessage)} value={message} className="fixedSize" name="message" id="message" rows="3" ></textarea>
                        </div>
                    </div>
                    <ul className="actions">
                        <li>
                            <button className="btn" onClick={sendIt}>Envoyer</button>
                        </li>
                    </ul>
                </div>
            </section> */}
            <section className="split contact">
                <section className="alt">
                    <h3>Adresse</h3>
                    <p>10 Allée du Clos des Mûres, <br /> 26240 Laveyron/France </p>
                </section>
                <section className="alt">
                    <h3>Téléphone</h3>
                    <p>
                        <a href="tel:+33766422645">(+33)766422645</a><br />
                        <a href="tel:+33617015964">(+33)617015964</a>
                    </p>
                </section>
                <section>
                    <h3>Email</h3>
                    <p><a href="mailto:creacolorsa@gmail.com">creacolorsa@gmail.com</a></p>
                </section>
                <section>
                    <h3>Social</h3>
                    <ul className="icons alt">
                        <li><a href="https://wa.me/33617015964" className="icon brands alt fa-whatsapp"><span className="label">Whatsapp</span></a></li>
                        {/* <li><a href="#!" className="icon brands alt fa-facebook-f"><span className="label">Facebook</span></a></li> */}
                        <li><a href="https://www.instagram.com/creacolorsafrique25?igsh=OG4xNnM0MnY3Ynh3" className="icon brands alt fa-instagram"><span className="label">Instagram</span></a></li>
                        <li><a href="https://www.tiktok.com/@cracolorsafrique?_t=ZN-90eh51gS5F0&_r=1" className="icon brands alt fa-tiktok"><span className="label">Tiktok</span></a></li>
                    </ul>
                </section>
            </section>
        </footer>
    )
}

